export {
    IconAdobeCC,
    IconArgo,
    IconAWS,
    IconConfluence,
    IconCypress,
    IconDocker,
    IconFigma,
    IconJavaScript,
    IconJest,
    IconJira,
    IconKotlin,
    IconKubernetes,
    IconNest,
    IconNext,
    IconNode,
    IconPostman,
    IconReact,
    IconSalesforce,
    IconSwift,
    IconTerraform,
    IconTypeScript,
} from './icon';
